import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ColumnModel } from "@syncfusion/ej2-vue-grids";
import { getCurrentInstance, onBeforeMount, ref } from "vue";
import BaseGridView from "../../common/BaseGridView.Component.vue";
import { SearchOption, TemplateDef } from "../../common/CommonInterfaces";


export default /*@__PURE__*/_defineComponent({
  __name: 'CustomDimensionSettingComponent',
  setup(__props) {

let columnDef = ref([] as ColumnModel[]);
const _searchOptions = {
  fields: ["company.Name", "name", "ordinal"],
  operator: "contains",
  ignoreCase: true,
} as SearchOption;

const templateDef: TemplateDef = {
  prefix: "dimensionSetting",
  columnNames: ["isActive"],
};

const app = getCurrentInstance();

onBeforeMount(() => {
  assignColumnDef();
});

const assignColumnDef = () => {
  const instance = app?.proxy;
  columnDef.value = [
    {
      field: "companyName",
      headerText: instance?.$t("companyName"),
      textAlign: "Center",
    },
    {
      field: "isActive",
      headerText: instance?.$t("status"),
      template: "dimensionSetting_isActive",
    },
    { field: "name", headerText: instance?.$t("name") },
    { field: "ordinal", headerText: instance?.$t("ordinal") },
  ];
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseGridView, {
    endpoint: "v1/CustomDimensionSetting/GetData",
    pageTitle: _ctx.$t('Custom Dimension Settings'),
    columnDef: (_unref(columnDef) as Array<ColumnModel>),
    searchOptions: _searchOptions,
    templateDef: templateDef
  }, {
    dimensionSetting_isActive: _withCtx(({ rowData }) => [
      _createElementVNode("span", {
        class: _normalizeClass(rowData.value ? 'badge badge-success' : 'badge badge-danger')
      }, _toDisplayString(rowData.value ? "Active" : "Inactive"), 3)
    ]),
    _: 1
  }, 8, ["pageTitle", "columnDef"]))
}
}

})